import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';
import { Smartphone, Monitor, Share2 } from 'lucide-react';

const TechSocialLandingPage = () => {
  const features = [
    {
      icon: <Smartphone size={20} />,
      title: "Device Library",
      description: "Latest iPhone, Pixel, and MacBook mockups updated weekly."
    },
    {
      icon: <Monitor size={20} />,
      title: "Screen Reflections",
      description: "AI-generated glare and reflections for photorealistic UI presentation."
    },
    {
      icon: <Share2 size={20} />,
      title: "Social Sizes",
      description: "Auto-export for Instagram Stories, Twitter headers, and LinkedIn."
    }
  ];

  return (
    <ComingSoonPage 
      title="Tech & Social Suite"
      subtitle="Showcase your apps and websites on the latest devices. Join the waitlist to get early access to our digital mockup tools."
      progress={70}
      statusText="Building Device Library..."
      toolId="tech-social"
      features={features}
    />
  );
};

export default TechSocialLandingPage;